// Jedinstvena tačka detekcije MAUI shell konteksta za celu (kiosk) aplikaciju.
// NEZAVISNA je od environment.nativeApp: WSService i drugi DI provideri se konstruišu pre
// nego što SetEnvironmentFlags (APP_INITIALIZER) postavi environment.nativeApp, pa čitanje
// tog flag-a u tom trenutku daje pogrešan rezultat. Ova funkcija čita direktno iz URL-a
// (?native=1) pa iz localStorage zapisa, i sama persistuje param — pozovi je svuda gde treba
// provera "da li radimo unutar native aplikacije".
//
// environment.nativeApp se i dalje održava (SetEnvironmentFlags ga postavi na isNativeShell())
// isključivo kao izvedeni keš za template binding-e; nemoj duplirati detekciju drugde.
export function isNativeShell(): boolean {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    const param = new URL(window.location.href).searchParams.get('native');
    if (param != null) {
      // Persistuj jer Angular navigacija odbaci ?native query param posle prvog učitavanja.
      try { localStorage.setItem('nativeApp', param); } catch { }
      return param === '1';
    }

    return localStorage.getItem('nativeApp') === '1';
  } catch {
    return false;
  }
}
